let apiHost = null;
/**
 * Returns `{ apiHost }`, where `apiHost` is the origin the bundle was served
 * from, so API calls target the bundle's origin rather than the host page's.
 */
export function getApiHost() {
  apiHost ??= new URL(import.meta.url).origin;

  return { apiHost };
}
